import personalizeService from '../utils/rbmc.personalizeService';
import urlUtils from '../utils/rbmc.url-utils';
import logger from '../utils/rbmc.logger';
import plp from '../plp/rbmc.plp-services';

const employee = {
    fetchEmployeeGroups() {
        personalizeService.getPersonalizedData().then((data) => {
                    let userGroups = data.userGroups || [];

                    this.unveilEmployeeSections(userGroups);
                    this.loadProducts();
                }, (jqXHR) => {
                    logger.error(`fetchEmployeeGroup, code: ${jqXHR.status}`);
                }
        )
    },
    unveilEmployeeSections(userGroups) {
        if (userGroups.length > 1) {
            userGroups.forEach((element) => {
                $(`.grp-${element}`).removeClass('d-none');
            })
        }
    },
    loadProducts() {
        if (RedBull.config.employee && RedBull.config.employee.restrictedCategory) {
            $.ajax({
                url:    `${urlUtils.getBaseUrl()}restrictedproducts/${RedBull.config.employee.restrictedCategoryCode}/`,
                method: 'GET',
                cache:  false
            }).then((data) => {
                plp.exchangeProducts(data);
                plp.replacePagination(data);
            }, (jqXHR) => {
                //restricted site not available for the user -> redirect
                window.location.replace(urlUtils.getBaseUrl());
            });
        }
    }
};

employee.fetchEmployeeGroups();

export default employee;
